import React, {useState} from "react";
import { Link } from "react-router-dom";
import GuiaPopup from '../../components/GuidePopup';
const AboutUs = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);


  const aboutUsIntro = () => {
    return (
      <div className="slider-btn btn-hover" style={{ position: "inherit" }}>
        <Link
          style={{
            position: "inherit",
            margin: 0,
            marginTop: "1rem",
            border: "none",
            color: "#fff",
          }}
          className="animated rounden-btn"
          onClick={() => setShow(true)}
        >
          VER MÁS
        </Link>
      </div>
    );
  };

  return (
    <>
    <GuiaPopup open={show} onClose={handleClose} />
      <div
        style={{
          backgroundImage: `url(${
            process.env.PUBLIC_URL + "/assets/img/bg/guia.jpg"
          })`,
          paddingTop: "16rem",
        }}
       
        className=" welcome-content bg-contain-mobile"
      >
        {aboutUsIntro()}
      </div>
    </>
  );
};

export default AboutUs;
